<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="600px">
      <v-card>
        <v-form
          ref="form"
          v-model="valid"
          method="post"
          enctype="multipart/form-data"
          lazy-validation
        >
          <v-card-title>
            <span class="headl">NUEVA TIENDA</span>
            <!-- <span>userID: {{ userId }}</span> -->
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    ref="name_shop"
                    v-model="name_shop"
                    :rules="nameRules"
                    label="Nombre de la tienda"
                    required
                  ></v-text-field>

                  <v-text-field
                    ref="address"
                    v-model="address"
                    :rules="inputRules"
                    label="Dirección fisica de su tienda"
                    required
                  ></v-text-field>

                  <v-text-field
                    ref="numContact"
                    v-model="numContact"
                    :rules="inputRules"
                    label="Numero de contacto"
                    required
                  ></v-text-field>
                  <v-text-field
                    ref="instagram"
                    v-model="instagram"
                    :rules="inputRules"
                    label="Instagram"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <div v-if="imgShop" class="preview_img">
                    <img :src="preview" />
                  </div>
                  <v-file-input
                    accept="image/*"
                    v-model="imgShop"
                    @change="onFileChange"
                    ref="imgShop"
                    name="imgShop"
                    label="Logo de la tienda"
                  ></v-file-input>
                  <v-select
                    ref="category"
                    v-model="category"
                    :items="itemsCategories"
                    :rules="[(v) => !!v || 'La categoria es requerida']"
                    label="Categoria"
                    required
                  ></v-select>
                  <v-text-field
                    ref="celContact"
                    v-model="celContact"
                    :rules="inputRules"
                    label="Celular de contacto"
                    required
                  ></v-text-field>
                  <v-text-field
                    ref="face"
                    v-model="face"
                    :rules="inputRules"
                    label="Facebook"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    ref="country"
                    v-model="country"
                    :items="itemsContry"
                    :rules="[(v) => !!v || 'El pais es requerido']"
                    label="País"
                    required
                  ></v-select>
                  <v-text-field
                    ref="mailSuport"
                    v-model="mailSuport"
                    :rules="emailRules"
                    label="Correo Electronico de soporte"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6"></v-col>
                <v-col cols="12" sm="6"></v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="ctn_btn_shop">
              <v-btn large text @click.stop="show = false">Cerrar</v-btn>
              <v-btn :disabled="!valid" depressed large color="primary" @click="validate">GUARDAR</v-btn>
            </div>

            <!-- <v-btn color="blue darken-1" text @click.stop="show = false"
            >Save</v-btn>-->
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
//import AlertMsj from '@/components/dashboard/AlertMsj.vue';

export default {
  props: ["visible"],
  data() {
    return {
      name_shop: null,
      userID: null,
      address: null,
      numContact: null,
      instagram: null,
      celContact: null,
      face: null,
      imgShop: null,
      mailSuport: null,
      urlName: null,
      category: null,
      itemsCategories: null,
      itemsContry: ["Colombia"],
      preview: null,
      msn: {
        flat: true,
        msj: "Ok!"
      },
      country: null,
      inputRules: [v => !!v || "El campo es requerido"],
      nameRules: [v => !!v || "El nombre es requerido"],
      emailRules: [
        v =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "El formato no es valido"
      ],
      valid: true,
      msj: null
    };
  },
  mounted() {
    this.categoryShop();
    this.userID = this.userId;
    this.itemsCategories = this.getCateShop;
  },
  methods: {
    ...mapActions(["listShops", "newShop", "categoryShop", "alertGeneral"]),

    validate() {
      if (this.$refs.form.validate()) {
        //this.snackbar = true;
        this.registerShop();
        //router.push({ path: "/editshop" });
      }
    },
    onFileChange(e) {
      if (this.imgShop != null) {
        const file = e;
        //console.log("obj", e);
        //console.log("obj", file);
        this.preview = URL.createObjectURL(file);
      } else {
        this.preview = null;
      }
    },
    nameUrl() {
      const str = this.name_shop.replace(/ /g, "");
      this.urlName = str + Math.floor(Math.random() * (1 - 999) + 999);
    },
    registerShop() {
      try {
        // generate urlname
        this.nameUrl();
        // ref form
        //const params = new URLSearchParams();
        const formData = new FormData();

        formData.append("name_shop", this.name_shop);
        formData.append("user", this.userID);
        formData.append("address", this.address);
        formData.append("numContact", this.numContact);
        formData.append("imgShop", this.imgShop);
        //console.log(this.imgShop);
        formData.append("instagram", this.instagram);
        formData.append("celContact", this.celContact);
        formData.append("face", this.face);
        formData.append("mailSuport", this.mailSuport);
        formData.append("urlName", this.urlName);
        formData.append("category", this.category);
        formData.append("country", this.country);
        // call store api
        //console.log("data send", formData);
        this.newShop(formData);
        // close modal
        this.show = false;
        // reset form
        this.$refs.form.reset();
        // update table shop
        this.listShops();
        this.alertGeneral({
          flat: true,
          msj: "¡Felicitaciones! La tienda se ha creado."
        });
      } catch (error) {
        this.alertGeneral({
          flat: true,
          msj: "¡Huy! Ocurrió un error, inténtelo más tarde."
        });
        this.errmensaje = "Ops! ocurrio un error con el servidor";
      }
    }
  },
  computed: {
    ...mapGetters(["userId", "getCateShop"]),
    isActive() {
      return this.valid;
    },

    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    }
  }
};
</script>

<style lang="scss">
span.headl {
  font-family: "Roboto Condensed", sans-serif !important;
  font-size: 1.5rem !important;
}
.preview_img {
  width: 100%;
  height: 64px;
  padding: 5px;
  margin-bottom: 15px;
  img {
    max-width: 100%;
    height: 64px;
    object-fit: contain;
  }
}
.ctn_btn_shop {
  button.v-btn {
    min-width: 120px !important;
  }
}
</style>
